var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-marker"},[_c('div',{staticClass:"model-marker-title"},[_vm._v(_vm._s(_vm.item.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }